"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_modal_1 = require("@doordash/component-modal");
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var RiskModal_1 = __importDefault(require("../../Common/RiskModal/RiskModal"));
var enums_1 = require("../../Common/utils/enums");
var useTracking_1 = __importDefault(require("../../Common/utils/useTracking"));
var StripeContainer_1 = __importDefault(require("../StripeContainer"));
var useVgsPaymentConfig_1 = __importDefault(require("../utils/useVgsPaymentConfig"));
var VerifyCardTemplate_1 = __importDefault(require("../VerifyCardTemplate"));
var VerifyPaymentCardContext_1 = require("../VerifyPaymentCardContext");
var VerifyPaymentCardStrings_1 = __importDefault(require("../VerifyPaymentCardStrings"));
var VgsContainer_1 = __importDefault(require("../VgsContainer"));
var CardReentryModalTitle_1 = __importDefault(require("./CardReentryModalTitle"));
var CardReentrySubmit_1 = __importDefault(require("./CardReentrySubmit"));
var VgsCardReentryChallenge_1 = __importDefault(require("./VgsCardReentryChallenge"));
var CardReentryChallenge = function (_a) {
    var disableDismiss = _a.disableDismiss, orderCart = _a.orderCart, paymentConfig = _a.paymentConfig, stripeKey = _a.stripeKey;
    var _b = useVgsPaymentConfig_1["default"](paymentConfig), isFraudVgsProviderEnabled = _b.isFraudVgsProviderEnabled, vgsConfig = _b.vgsConfig;
    var _c = useTracking_1["default"](), trackLoad = _c.trackLoad, trackClose = _c.trackClose;
    React.useEffect(function () {
        trackLoad(orderCart.id);
    }, []);
    return (React.createElement(RiskModal_1["default"], { disableDismiss: disableDismiss, onCloseTracking: trackClose, primaryActionText: VerifyPaymentCardStrings_1["default"].verifyAndPlaceOrder(), renderContentHeader: function (_a) {
            var subtitle = _a.subtitle, title = _a.title;
            return (React.createElement(CardReentryModalTitle_1["default"], { subtitle: subtitle, title: title }));
        }, size: component_modal_1.Modal.Sizes.Small, subtitle: VerifyPaymentCardStrings_1["default"].cardReentryDescription(), title: VerifyPaymentCardStrings_1["default"].cardReentryTitle() },
        React.createElement(VerifyPaymentCardContext_1.VerifyPaymentCardProvider, { orderCart: orderCart, paymentConfig: paymentConfig, stripeKey: stripeKey },
            React.createElement(design_language_1.StackChildren, null,
                React.createElement(VerifyCardTemplate_1["default"], { hideExpiryDetails: true }),
                isFraudVgsProviderEnabled ? (React.createElement(VgsContainer_1["default"], { vgsConfig: vgsConfig }, function (isVgsLoaded, vgsErrorMessage) { return (React.createElement(VgsCardReentryChallenge_1["default"], { isVgsLoaded: isVgsLoaded, vgsErrorMessage: vgsErrorMessage })); })) : (React.createElement(StripeContainer_1["default"], { stripeKey: stripeKey },
                    React.createElement(CardReentrySubmit_1["default"], { tokenizationProvider: enums_1.TokenizationProvider.Stripe })))))));
};
exports["default"] = CardReentryChallenge;
